import React, {Component} from 'react'
import {inject, observer} from 'mobx-react'
import {Button, Form, Row, Col, Select, Input} from 'antd'
import {PAGE_SIZE_DEFAULT} from '../../../constants/appConstant'
import {withTranslation} from 'react-i18next'
const storage = window.localStorage

@inject('marketingSmsManagementStore', 'accountStore')
@observer
class SearchForm extends Component {
  state = {
    addModalVisible: false,
    isValid: ''
  }
  formRef = React.createRef()

  componentDidMount() {
    const {marketingSmsManagementStore, accountStore, sourceType, isValid} = this.props
    const { generateID } = marketingSmsManagementStore
    const {accountInfos} = accountStore
    const infos = JSON.parse(storage.getItem('accountInfos'))
    marketingSmsManagementStore.onPhoneAction({
      'sourceType': sourceType,
      'phone': '',
      'isValid': isValid,
      'taskGroupId': generateID,
      'isPowerUser' : accountInfos?.data?.isPowerUser || infos?.data?.isPowerUser,
      'page': 1,
      'size': PAGE_SIZE_DEFAULT
    })
    marketingSmsManagementStore.onGetStatus('sourceType')
    this.formRef.current.setFieldsValue({
      'isValid': isValid,
    })
    this.setState({isValid: isValid})
  }

  handleSearch = () => {
    const {marketingSmsManagementStore, accountStore, sourceType} = this.props
    const { generateID } = marketingSmsManagementStore
    const {accountInfos} = accountStore
    const infos = JSON.parse(storage.getItem('accountInfos'))
    this.formRef.current.validateFields().then(fieldsValue => {
      let params = {
        'sourceType': sourceType,
        'phone': fieldsValue.phone,
        'isValid': this.state.isValid,
        'taskGroupId': generateID,
        'isPowerUser' : accountInfos?.data?.isPowerUser || infos?.data?.isPowerUser,
        'page': 1,
        'size': PAGE_SIZE_DEFAULT
      }
      marketingSmsManagementStore.onPhoneAction(params)
    }).catch(err => {
    })
  }
  handleClearPhone = () => {
    const {marketingSmsManagementStore, type, smsType, sourceType} = this.props
    const { generateID } = marketingSmsManagementStore
    marketingSmsManagementStore.onClearPhoneAction({
      "sourceType": sourceType,
      "isValid": this.state.isValid,
      "taskGroupId": generateID,
    }).then(res=> {
      if (res?.data?.code === 0) {
        marketingSmsManagementStore.onStatisticsAction({
          "smsType": smsType,
          "taskGroupId": generateID,
          "taskType": type
        })
      }
    })
  }
  onChangeIsValid = (value) => {
    this.setState({isValid: value})
  }

  render() {
    const {t} = this.props

    const {expoList} = {
      expoList: [
        {
          code: '0',
          value: '有效'
        },
        {
          code: '1',
          value: '无效'
        }
      ]
    }

    return (
      <>
        <Form ref={this.formRef} size="middle" className="searchForm">
          <Row gutter={[10, 10]}>
            <Col span={6}>
              <Form.Item name="phone"
                rules={[{
                  message: `${t(`general.pleaseEnter`)} ${t(`marketingManagement.keywords`)} ${t(`general.withoutSpecialChats`)}`,
                  pattern: new RegExp(/^[^&|;\\\s][^&|;\\]*$/)
                }]}
              >
                <Input maxLength={100} placeholder={t(`general.pleaseEnter`)} allowClear/>
              </Form.Item>
            </Col>
            <Col span={6}>
                <Form.Item name="isValid">
                  <Select placeholder={t(`general.pleaseSelect`)} showSearch filterOption={(input, option) =>
                    option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                  } onChange={this.onChangeIsValid}>
                    {expoList?.map(item => (<Select.Option key={item?.code} value={item?.code}>{item?.value}</Select.Option>))}
                  </Select>
                </Form.Item>
            </Col>
            <Col span={12} style={{ textAlign: 'right'}}>
              <Button onClick={this.handleSearch} className="ant-btn-red">{t(`general.search`)}</Button>
              <Button onClick={this.handleClearPhone} type="primary">{t(`general.clearPhone`)}</Button>
            </Col>
          </Row>
        </Form>
      </>
    )
  }
}

export default withTranslation()(SearchForm)
